var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageSuccess48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconSuccess48",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,0 C37.2489591,0.0141725482 47.9858275,10.7510409 48,24 C48,37.254834 37.254834,48 24,48 C10.745166,48 0,37.254834 0,24 C0,10.745166 10.745166,0 24,0 Z M24,3.42857143 C12.6387137,3.42857143 3.42857143,12.6387137 3.42857143,24 C3.42857143,35.3612863 12.6387137,44.5714286 24,44.5714286 C35.3561948,44.559146 44.559146,35.3561948 44.5714286,24 C44.5714286,12.6387137 35.3612863,3.42857143 24,3.42857143 Z M31.6114286,16.1777143 C32.2570486,15.5092545 33.2131146,15.2411676 34.1121617,15.476493 C35.0112088,15.7118184 35.7133244,16.4139341 35.9486498,17.3129812 C36.1839752,18.2120283 35.9158884,19.1680942 35.2474286,19.8137143 L35.2474286,19.8137143 L21.5331429,33.528 C20.5336905,34.527196 18.9151904,34.5325553 17.9091429,33.54 L17.9091429,33.54 L11.052,26.7771429 C10.0408455,25.7797166 10.0297166,24.1514402 11.0271429,23.1402857 C12.0245691,22.1291312 13.6528455,22.1180023 14.664,23.1154286 L14.664,23.1154286 L19.7022857,28.0868571 L31.6114286,16.1794286 Z",
    id: "Combined-Shape-Copy",
    fill: "#177D3D"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSuccess48);
export default __webpack_public_path__ + "static/media/messageSuccess48.d24fc32336694f43091bbc4d068f8aeb.svg";
export { ForwardRef as ReactComponent };